import React, { FunctionComponent, useState } from "react";
import { Aside, IconButton, ListActionButtonProps, Stack } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { CloneMuxSpecificationForm } from "../forms/clone/CloneMuxSpecificationForm";
import { MuxSpecificationListingItem } from "../MuxSpecificationListingItem";

export const CloneMuxSpecificationButton: FunctionComponent<ListActionButtonProps<MuxSpecificationListingItem>> = (
    props: ListActionButtonProps<MuxSpecificationListingItem>
) => {
    const { itemId } = props;
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    //ask if AccessRights are correct
    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdAdmin]}>
            <>
                <IconButton
                    tooltipContent="Edit"
                    iconProps={{ iconName: "Tab" }}
                    disabled={props.disabled}
                    onClick={openAside}
                />
                <Aside type={"form"} isOpen={isAsideOpen} headerText="Clone Mux Specification" onDismiss={closeAside}>
                    <Stack>
                        <CloneMuxSpecificationForm onCancel={closeAside} onSubmit={handleFormSubmit} itemId={itemId} />
                    </Stack>
                </Aside>
            </>
        </AuthorizationWrapper>
    );
};
